import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ie-offic-7",
  "use": "icon-ie-offic-7-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ie-offic-7\">\r\n    <path d=\"M85.357714 207.213714c0-67.291429 54.564571-121.856 121.856-121.856h609.572572c67.291429 0 121.856 54.564571 121.856 121.856v609.572572c0 67.291429-54.564571 121.856-121.929143 121.856H207.213714c-67.291429 0-121.929143-54.564571-121.929143-121.856V207.213714z\" fill=\"#FF7875\" p-id=\"2266\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol